import { ContentBody } from "@app/components/core/ContentBody/ContentBody"
import { ContentHeader } from "@app/components/core/ContentHeader/ContentHeader"
import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation, useNavigationData } from "@app/components/navigation/NavigationHandler"
import ImagePage from "@app/components/pageTypes/ImagePage/ImagePage"
import AnimatedRoute, { AnimationTypes } from "@app/components/routing/AnimatedRoute/AnimatedRoute"
import { useRaiseError } from "@app/store/actions/errorActions"
import { useGetStrings } from "@app/store/service/cmsService"
import { useStartVerificationByMail } from "@app/store/service/connectorService"
import { useViewport } from "@tecreation/funnel-components"
import { useCallback } from "react"

const NotVerifiedaccount = () => {
	const { sm, md } = useViewport()
	const { replace } = useCustomNavigation()
	const { email, relationToken } = useNavigationData() || {}
	const {
		data: { buttonSendAgain, accountNotVerifiedTitle, accountNotVerifiedInfo },
	} = useGetStrings(undefined, { defaultData: {} })
	const [sendMail, { isLoading }] = useStartVerificationByMail()
	const raiseError = useRaiseError()
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const submit = useCallback(async () => {
		try {
			await sendMail({ email, relationToken }).then(() => {
				replace("/login?action=resendMail", AnimationTypes.stack, null, "pop")
			})
		} catch (e) {
			raiseError(e, undefined, true)
		}
	})

	return (
		<AnimatedRoute className="h-100">
			<ImagePage>
				<ContentHeader
					canGoBack
					colorStyle="white"
					animation={AnimationTypes.stack}
					customReturnFunction={() => {
						replace("/login", AnimationTypes.slide, null, "POP")
					}}
				>
					{accountNotVerifiedTitle}
				</ContentHeader>
				<ContentBody className="container-md f4 mt-6">
					<div>{accountNotVerifiedInfo}</div>
					<div className="mt-4 flex flex-center">
						<Button style="primary" onClick={submit} fillWidth={sm || md} isLoading={isLoading}>
							{buttonSendAgain}
						</Button>
					</div>
				</ContentBody>
			</ImagePage>
		</AnimatedRoute>
	)
}

export default NotVerifiedaccount
